import { useRef, useEffect, useState } from 'react';

export const useSound = (soundUrl) => {
    const audioRef = useRef(new Audio(soundUrl));
    const [isMuted, setIsMuted] = useState(false);

    const play = () => {
        if (!isMuted) {
            audioRef.current.currentTime = 0;
            audioRef.current.play().catch(error => console.log("Audio playback failed:", error));
        }
    };

    const toggleMute = () => {
        audioRef.current.muted = !isMuted;
        setIsMuted(!isMuted);
    };

    useEffect(() => {
        return () => {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        };
    }, []);

    return { play, toggleMute, isMuted };
}; 